require('babel-polyfill');
window.jquery = window.jQuery = window.$ = require('jquery');
window.Popper = require('popper.js');
// require('bootstrap');
require('bootstrap-material-design');
require( 'datatables.net' )(window, $);
require( 'datatables.net-bs4' )(window, $);

// Project
require('./propriolocation');
require('./cleave');
require('./datepicker');
require('./modalConfirm');
require('./popup');
require('./cart');
require('./responsive-pagination');
require('./revision-request');
require('./sign-request');
require('./switch-lang');
require('./form-create-lease');
require('./admin-forms');
require('./admin-change-role-member');
require('./browser-detection');
require('./password-revealer');
require('./requestLocationSteps');
require('./request-location-address-validation');
require('./autocomplete-address');
require('./modal-show');
require('./message-important');
require('./communications');
require('./delayed-focus');
require('./signature-pad');
require('./alert');
require('./specify-fields');
require('./input-toggle-display');
require('./modal-intro');
require('./input-toggle-disabled');
require('./member-approve-policy');
require('./input-hint');

var Inputmask = require('inputmask');

window.Quill = require( 'quill' );

(function() {
    'use strict';
    // onChange trigger loop because BMD will trigger onChange inside setInterval as soon as onFocus is triggered
    // {autofill: false}
    // $('body').bootstrapMaterialDesign();

    var dtLangConfig = {};
    var lang = document.documentElement.lang;

    if (lang === 'fr') {
        dtLangConfig = { "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/French.json" };
    } else {
        dtLangConfig = { "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/English.json" };
    }



    $(document).ready(function() {

        $('body').bootstrapMaterialDesign();
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover({
            trigger: 'hover'
        });

        $('#passwordTooltip').on('show.bs.tooltip', function () {
            var $tooltip = $('#passwordTooltip');
            $tooltip.html('(&nbsp;x&nbsp;)');
        });
        $('#passwordTooltip').on('hide.bs.tooltip', function () {
            var $tooltip = $('#passwordTooltip');
            $tooltip.html('(&nbsp;?&nbsp;)');
        });

        $('.btn-send').click(function () {
            var formId = $(this).data('formid');
            var email = $(this).data('email');
            var language = $(this).data('language');
            $('#sendId').val(formId);
            $('#email').val(email);
            $('#language').val(language);

            if ($('#email').val() !== '') {
                $('#email').prop('readonly', true);
            }
        });

        $('.btn-restore').click(function () {
            var formid = $(this).data('formid');
            $('#restoreId').val(formid);
        });

        $('.btn-delete').click(function () {
            var formId = $(this).data('formid');
            var tab = $(this).data('tab');
            $('#deleteId').val(formId);
            $('input.tab').val(tab);
        });

        $('.check-delete').click(function () {
            var formId = $(this).data('formid');
            $('#confirmDeleteFormId').val(formId);
        });

        $('.btn-pe').click(function () {
            var formId = $(this).data('formid');
            $('#peId').val(formId);
        });

        $('[data-table="default"]').DataTable({
            "paging": false,
            // "pageLength": 20,
            "lengthChange": false,
            "info" : false,
            "searching": true,
            "language": dtLangConfig,
            "order" : [
                [0, 'desc']
            ],
            "columnDefs": [{
                "targets": 4,
                "orderable": false
            }],
            "fnDrawCallback": function(oSettings) {
                if (oSettings._iDisplayLength == -1 || oSettings._iDisplayLength >= oSettings.fnRecordsDisplay()) {
                    $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                } else {
                    $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                }
            }
        });

        $('[data-table="addresses"]').DataTable({
            "paging": true,
            "pageLength": 20,
            "lengthChange": false,
            "info" : false,
            "searching": false,
            "language": dtLangConfig,
            "columnDefs": [{
                "targets": [2, 3],
                "orderable": false
            }],
            "fnDrawCallback": function(oSettings) {
                if (oSettings._iDisplayLength == -1 || oSettings._iDisplayLength >= oSettings.fnRecordsDisplay()) {
                    $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                } else {
                    $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                }
            }
        });

        $('.btn-logo-cancel').click(function () {
            $('#deleteLogo').prop('checked', false);
        });
        $('.btn-logo-delete').click(function () {
            $('#deleteLogo').prop('checked', true);
        });

        $('.btn-form-cancel').click(function () {
            var formId = $('#confirmDeleteFormId').val();
            $('#deleteForms_' + formId).prop('checked', false);
            checkButtonDelete();
        });
        $('.btn-form-delete').click(function () {
            var formId = $('#confirmDeleteFormId').val();
            $('#deleteForms_' + formId).prop('checked', true);
            checkButtonDelete();
        });

        $('.btn-form-all-cancel').click(function () {
            $('.check-delete').prop('checked', false);
            checkButtonDelete();
        });
        $('.btn-form-all-delete').click(function () {
            $('.check-delete').prop('checked', true);
            checkButtonDelete();
        });

        $('.btn-form-many-cancel').click(function () {
            $('.check-delete').prop('checked', false);
            checkButtonDelete();
        });
        $('.btn-form-many-delete').click(function () {
            $('#formDelete').submit();
        });

        $('#deleteAllForm').click(function(){
            $('.check-delete').not(this).prop('checked', this.checked);
            checkButtonDelete();
        });

        $('.check-delete').click(function(){
            checkButtonDelete();
        });

        $('#memberBuilding').change(function () {
            $('#recentForm').val(null);
            $('#recentFormButton').prop('disabled', true);
            if ($('#memberBuilding').val() != '') {
                $('#memberBuildingButton').prop('disabled', false);
            } else {
                $('#memberBuildingButton').prop('disabled', true);
            }
        });

        $('#recentForm').change(function () {
            $('#memberBuilding').val(null);
            $('#memberBuildingButton').prop('disabled', true);
            if ($('#recentForm').val() != '') {
                $('#recentFormButton').prop('disabled', false);
            } else {
                $('#recentFormButton').prop('disabled', true);
            }
        });

        $('.signature-optin').change(function() {
            var $button = $('.signature-button');
            if (this.checked) {
                $button.prop('disabled', false);
            } else {
                $button.prop('disabled', true);
            }
        });

        $('.create-account-confirmation').change(function() {
            var $button = $('.create-account-button');
            if (this.checked) {
                $button.prop('disabled', false);
            } else {
                $button.prop('disabled', true);
            }
        });

        if ($('#tenant_nojob').length) {
            var $nojobReasonContainer = $('#nojob_reason_container');
            var $nojobRevenueContainer = $('#nojob_revenue_container');
            var $jobsContainer = $('#jobs_form_container');
            var $nojobReason = $('#tenant_nojobReason');
            var $nojobRevenue = $('#tenant_nojobRevenue');
            if ($('#tenant_nojob').is(':checked')) {
                hideJobFields();
            } else {
                showJobFields();
            }
        }

        $('#tenant_nojob').change(function () {
            if (this.checked) {
                hideJobFields();
            } else {
                showJobFields();
            }
        });

        function hideJobFields()
        {
            $nojobReasonContainer.prop('hidden', false);
            $nojobRevenueContainer.prop('hidden', false);
            $nojobReason.prop('disabled', false);
            $nojobReason.prop('required', true);
            $nojobRevenue.prop('disabled', false);
            $nojobRevenue.prop('required', true);
            $jobsContainer.prop('hidden', true);
            $jobsContainer.find(':input').prop('disabled', true);
        }

        function showJobFields()
        {
            $nojobReasonContainer.prop('hidden', true);
            $nojobRevenueContainer.prop('hidden', true);
            $nojobReason.prop('disabled', true);
            $nojobReason.prop('required', false);
            $nojobRevenue.prop('disabled', true);
            $nojobRevenue.prop('required', false);
            $jobsContainer.prop('hidden', false);
            $jobsContainer.find(':input').prop('disabled', false);
        }

        function checkButtonDelete() {
            var $deleteButton = $('#deleteFormButton');
            if ($('.check-delete:checked').length) {
                $deleteButton.prop('disabled', false);
            } else {
                $deleteButton.prop('disabled', true);
            }
        }

        $('#tenant_jobs_1_salary, #tenant_jobs_1_rate').on('change', function(){
            if ($('#tenant_jobs_1_company').length) {
                // If a company is entered, at least one of the two fields must be filled.
                if ($('#tenant_jobs_1_salary').val().length > 0 || $('#tenant_jobs_1_rate').val().length > 0) {
                    $('#tenant_jobs_1_salary, #tenant_jobs_1_rate').siblings('.js-error-salaire').hide()
                }
                else {
                    $('#tenant_jobs_1_salary, #tenant_jobs_1_rate').siblings('.js-error-salaire').show()
                }
            }
        })

        $('#tenant_jobs_2_salary, #tenant_jobs_2_rate').on('change', function(){
            if ($('#tenant_jobs_2_company').length) {
                // If a company is entered, at least one of the two fields must be filled.
                if ($('#tenant_jobs_2_salary').val().length > 0 || $('#tenant_jobs_2_rate').val().length > 0) {
                    $('#tenant_jobs_2_salary, #tenant_jobs_2_rate').siblings('.js-error-salaire').hide()
                }
                else {
                    $('#tenant_jobs_2_salary, #tenant_jobs_2_rate').siblings('.js-error-salaire').show()
                }
            }
        })

        if ($("input[name=signatureType]:checked").val() == "handwritten") {
            $('.js-print-message').show()
        }
        else {
            $('.js-print-message').hide()
        }

        $("input[name=signatureType]").on('change', function(){
            if ($(this).val() == "handwritten") {
                $('.js-print-message').show()
            }
            else {
                $('.js-print-message').hide()
            }
        })

        var $withTenant = $('[name="withTenant"]');
        var $tenantEmail = $('[name="tenantEmail"]');
        if ($withTenant.length && $tenantEmail.length) {
            $withTenant.on('change', function() {
                var steps = [2, 3, 4, 5, 7];

                if ($(this).val() === '0') {
                    $('.tenant-firstname-input').show();
                    $('.tenant-lastname-input').show();
                    $('.tenant-language-input').show();
                    $tenantEmail.closest('.form-group').show();
                    $tenantEmail.attr('required', 'required');

                    $.each(steps, function(stepIndex, step) {
                        var $a = $('.steps__link:eq(' + (step - 1) + ')');
                        var $span = $('<span>' + $a.html() + '</span>');

                        var attributes = $a.prop('attributes');

                        $.each(attributes, function(attrIndex, attr) {
                            $span.attr(attr.name, attr.value);
                        });

                        $span.addClass('is-complete');

                        $a.replaceWith($span);
                    });
                } else {
                    $('.tenant-firstname-input').hide();
                    $('.tenant-lastname-input').hide();
                    $('.tenant-language-input').hide();
                    $tenantEmail.closest('.form-group').hide();
                    $tenantEmail.removeAttr('required');

                    $.each(steps, function(stepIndex, step) {
                        var $span = $('.steps__link:eq(' + (step - 1) + ')');
                        var $a = $('<a>' + $span.html() + '</a>');

                        var attributes = $span.prop('attributes');

                        $.each(attributes, function(attrIndex, attr) {
                            $a.attr(attr.name, attr.value);
                        });

                        $a.removeClass('is-complete');

                        $span.replaceWith($a);
                    });
                }
            });
        }
    }); // END document ready

    var form_notice = document.querySelector('[form-notice-trigger]'),
        form_notice_span = document.querySelector('[form-notice-trigger] span'),
        html = document.querySelector('html');


    if(form_notice) {

        html.addEventListener('click', function(){
            closeNotice();
        });

        form_notice.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            if( this.classList.contains('form-notice--active')) {
                closeNotice();
            } else {
                openNotice();
            }
        });
    }

    function openNotice() {
        form_notice.classList.add('form-notice--active');
        if(form_notice_span !== null) {
            form_notice_span.innerHTML = "(&nbsp;x&nbsp)";
        }
    }

    function closeNotice() {
        form_notice.classList.remove('form-notice--active');
        if(form_notice_span !== null) {
            form_notice_span.innerHTML = "(&nbsp?&nbsp)";
        }
    }

    // Get anchor from url to open table tab
    var hash = window.location.hash.substr(1);
    if (hash.length > 0) {
        $('#' + hash).click();
    }

    $('#step3').on('submit', function () {
        $('#tenant_addresses_1_state').prop('disabled', false);
        $('#tenant_addresses_2_state').prop('disabled', false);
    });

    $('#step4').on('submit', function () {
        this.reportValidity();
        $('#tenant_jobs_1_state').prop('disabled', false);
        $('#tenant_jobs_2_state').prop('disabled', false);
    });

    function getStatesOfCountry(stateDropdown, code) {
        if (code !== '') {
            var countryCode = code;
            $('option', stateDropdown).each(function() {
                $(this).prop('hidden', true);
            });

            if (countryCode === 'US') {
                $('option[data-country-code="US"]', stateDropdown).prop('hidden', false);
            } else if (countryCode === 'CA') {
                $('option[data-country-code="CA"]', stateDropdown).prop('hidden', false);
            } else {
                $('option[data-country-code="IO"]', stateDropdown).prop('hidden', false);
            }
        }
    }

    function setPostalCodeMask(postalCodeElement, countryCode)
    {
        var jsElement = postalCodeElement[0];
        if (jsElement.inputmask) {
            jsElement.inputmask.remove();
        }

        if (jsElement.getAttribute('pattern')) {
            jsElement.removeAttribute('pattern');
        }

        var im = null;
        switch (countryCode) {
            case 'CA': {
                im = new Inputmask('A9A 9A9');
                im.mask(jsElement);
                jsElement.setAttribute('pattern', '[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d');
                break;
            }
            case 'US':
            case 'FR': {
                im = new Inputmask('99999');
                im.mask(jsElement);
                break;
            }
            default: {
                break;
            }
        }
    }

    if ($('#international-addresses-1').length && $('#international-addresses-2').length) {
        var internationalA1 = $('#international-addresses-1');
        var internationalA2 = $('#international-addresses-2');
        var countrySelect1 = $('#tenant_addresses_1_country');
        var countrySelect2 = $('#tenant_addresses_2_country');

        countrySelect1.on('change', function () {
            getStatesOfCountry($('#tenant_addresses_1_state'), $('option:selected', this).val());
            // $('#tenant_addresses_1_state').val($('#tenant_addresses_1_state option:first').val());

            //Let's reset the province/state value
            $('#tenant_addresses_1_state').prop("selectedIndex", 0);
            setPostalCodeMask($('#tenant_addresses_1_postalCode'), $('#tenant_addresses_1_country option:selected').val());
        });

        countrySelect2.on('change', function () {
            getStatesOfCountry($('#tenant_addresses_2_state'), $('option:selected', this).val());
            // $('#tenant_addresses_2_state').val($('#tenant_addresses_2_state option:first').val());

            //Let's reset the province/state value
            $('#tenant_addresses_2_state').prop("selectedIndex", 0);
            setPostalCodeMask($('#tenant_addresses_2_postalCode'), $('#tenant_addresses_2_country option:selected').val());
        });

        if (internationalA1.is(':checked')) {

            $('.international-subtitle-1').toggleClass('d-none');
            $('.bmd-help-1').hide();
            $('#tenant_addresses_1_country option').each(function () {
                if ($(this).val() === 'CA') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            if ($('#tenant_addresses_1_country').data('current') && $('#tenant_addresses_1_country').data('current').length !== 2) {
                $('#tenant_addresses_1_country').val($('#tenant_addresses_1_country option:first').val());
            }
            $('.state-label-interational').show();
            $('.state-label').hide();
            getStatesOfCountry($('#tenant_addresses_1_state'), $('#tenant_addresses_1_country option:selected').val());
            setPostalCodeMask($('#tenant_addresses_1_postalCode'), $('#tenant_addresses_1_country option:selected').val());
        } else {
            $('.bmd-help-1').show();
            $('#tenant_addresses_1_country option').each(function () {
                if ($(this).val() !== 'CA' && $(this).val() !== '') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            $('#tenant_addresses_1_country option[value=CA]').prop('selected', true);
            setPostalCodeMask($('#tenant_addresses_1_postalCode'), 'CA');
        }

        if (internationalA2.is(':checked')) {
            $('.international-subtitle-2').toggleClass('d-none');
            $('.bmd-help-2').hide();
            $('#tenant_addresses_2_country option').each(function () {
                if ($(this).val() === 'CA') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            if ($('#tenant_addresses_2_country').data('current') && $('#tenant_addresses_2_country').data('current').length !== 2) {
                $('#tenant_addresses_2_country').val($('#tenant_addresses_2_country option:first').val());
            }
            $('.state-label-interational').show();
            $('.state-label').hide();
            getStatesOfCountry($('#tenant_addresses_2_state'), $('#tenant_addresses_2_state option:selected').val());
            setPostalCodeMask($('#tenant_addresses_2_postalCode'), $('#tenant_addresses_2_country option:selected').val());
        } else {
            $('.bmd-help-2').show();
            $('#tenant_addresses_2_country option').each(function () {
                if ($(this).val() !== 'CA' && $(this).val() !== '' ) {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            $('#tenant_addresses_2_country option[value=CA]').prop('selected', true);
            setPostalCodeMask($('#tenant_addresses_2_postalCode'), 'CA');
        }

        internationalA1.on('change', function () {
            $('.international-subtitle-1').toggleClass('d-none');

            if ($(this).is(':checked')) {
                $('#tenant_addresses_1_postalCode').val($('#tenant_addresses_1_postalCode').attr('value'));
                $('.bmd-help-1').hide();

                $('#tenant_addresses_1_country').val($('#tenant_addresses_1_country option:first').val());
                $('#tenant_addresses_1_country option').each(function () {
                    if ($(this).val() === 'CA') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('.state-label-interational').show();
                $('.state-label').hide();

                //Remove the default Province if it was Canada
                getStatesOfCountry($('#tenant_addresses_1_state'), 'IO');
                setPostalCodeMask($('#tenant_addresses_1_postalCode'), 'IO');
                $('#tenant_addresses_1_state option:first').prop('selected', true);
            } else {
                $('#tenant_addresses_1_country option').each(function () {
                    if ($(this).val() !== 'CA' && $(this).val() !== '') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('#tenant_addresses_1_country option[value=CA]').prop('selected', true);
                $('.bmd-help-1').show();
                $('.state-label-interational').hide();
                $('.state-label').show();

                getStatesOfCountry($('#tenant_addresses_1_state'), 'CA');
                setPostalCodeMask($('#tenant_addresses_1_postalCode'), 'CA');
                $('#tenant_addresses_1_state option:first').prop('selected', true);
            }
        });

        internationalA2.on('change', function () {
            $('.international-subtitle-2').toggleClass('d-none');

            if ($(this).is(':checked')) {
                $('#tenant_addresses_2_postalCode').val($('#tenant_addresses_2_postalCode').attr('value'));
                $('.bmd-help-2').hide();
                $('#tenant_addresses_2_country').val($('#tenant_addresses_2_country option:first').val());
                $('#tenant_addresses_2_country option').each(function () {
                    if ($(this).val() === 'CA') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('.state-label-interational').show();
                $('.state-label').hide();

                //Remove the default Province if it was Canada
                getStatesOfCountry($('#tenant_addresses_2_state'), 'IO');
                setPostalCodeMask($('#tenant_addresses_2_postalCode'), 'IO');
                $('#tenant_addresses_2_state option:first').prop('selected', true);

            } else {
                $('#tenant_addresses_2_country option').each(function () {
                    if ($(this).val() !== 'CA' && $(this).val() !== '') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('#tenant_addresses_2_country option[value=CA]').prop('selected', true);
                $('.bmd-help-2').show();
                $('.state-label-interational').hide();
                $('.state-label').show();

                getStatesOfCountry($('#tenant_addresses_2_state'), 'CA');
                setPostalCodeMask($('#tenant_addresses_2_postalCode'), 'CA');
                $('#tenant_addresses_2_state option:first').prop('selected', true);
            }
        });
    }

    if ($('#international-job-1').length && $('#international-job-2').length) {
        var internationalJ1 = $('#international-job-1');
        var internationalJ2 = $('#international-job-2');
        var countryJobsSelect1 = $('#tenant_jobs_1_country');
        var countryJobsSelect2 = $('#tenant_jobs_2_country');

        countryJobsSelect1.on('change', function () {
            getStatesOfCountry($('#tenant_jobs_1_state'), $('option:selected', this).val());
            $('#tenant_jobs_1_state').val($('#tenant_jobs_1_state option:first').val());
            setPostalCodeMask($('#tenant_jobs_1_postalCode'), $('#tenant_jobs_1_country option:selected').val());
        });

        countryJobsSelect2.on('change', function () {
            getStatesOfCountry($('#tenant_jobs_2_state'), $('option:selected', this).val());
            $('#tenant_jobs_2_state').val($('#tenant_jobs_2_state option:first').val());
            setPostalCodeMask($('#tenant_jobs_2_postalCode'), $('#tenant_jobs_2_country option:selected').val());
        });

        if (internationalJ1.is(':checked')) {
            $('#tenant_jobs_1_country option').each(function () {
                if ($(this).val() === 'CA') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            if ($('tenant_jobs_1_country').data('current') && $('tenant_jobs_1_country').data('current').length !== 2) {
                $('#tenant_jobs_1_country').val($('#tenant_jobs_1_country option:first').val());
            }
            $('.state-label-interational').show();
            $('.state-label').hide();
            getStatesOfCountry($('#tenant_jobs_1_state'), $('#tenant_jobs_1_country option:selected').val());
            setPostalCodeMask($('#tenant_jobs_1_postalCode'), $('#tenant_jobs_1_country option:selected').val());
        } else {
            $('#tenant_jobs_1_country option').each(function () {
                if ($(this).val() !== 'CA' && $(this).val() !== '') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });

            $('#tenant_jobs_1_country option[value=CA]').prop('selected', true);
            setPostalCodeMask($('#tenant_jobs_1_postalCode'), 'CA');
        }

        internationalJ1.on('change', function () {

            if ($(this).is(':checked')) {
                $('#tenant_jobs_1_postalCode').val($('#tenant_jobs_1_postalCode').attr('value'));
                $('.bmd-help-1').hide();

                $('#tenant_jobs_1_country').val($('#tenant_jobs_1_country option:first').val());
                $('#tenant_jobs_1_country option').each(function () {
                    if ($(this).val() === 'CA') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('.state-label-interational').show();
                $('.state-label').hide();

                //Remove the default Province if it was Canada
                getStatesOfCountry($('#tenant_jobs_1_state'), 'IO');
                setPostalCodeMask($('#tenant_jobs_1_postalCode'), 'IO');
                $('#tenant_jobs_1_state option:first').prop('selected', true);
            } else {
                $('#tenant_jobs_1_country option').each(function () {
                    if ($(this).val() !== 'CA' && $(this).val() !== '') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('#tenant_jobs_1_country option[value=CA]').prop('selected', true);
                $('#tenant_jobs_1_state').val($('#tenant_jobs_1_state option:first').val());

                $('.bmd-help-1').show();
                $('.state-label-interational').hide();
                $('.state-label').show();
                getStatesOfCountry($('#tenant_jobs_1_state'), 'CA');
                setPostalCodeMask($('#tenant_jobs_1_postalCode'), 'CA');
                $('#tenant_jobs_1_state option:first').prop('selected', true);
            }
        });

        if (internationalJ2.is(':checked')) {
            $('#tenant_jobs_2_country option').each(function () {
                if ($(this).val() === 'CA') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            if ($('tenant_jobs_2_country').data('current') && $('tenant_jobs_2_country').data('current').length !== 2) {
                $('#tenant_jobs_2_country').val($('#tenant_jobs_2_country option:first').val());
            }
            $('.state-label-interational').show();
            $('.state-label').hide();
            getStatesOfCountry($('#tenant_jobs_2_state'), $('#tenant_jobs_2_country option:selected').val());
            setPostalCodeMask($('#tenant_jobs_2_postalCode'), $('#tenant_jobs_2_country option:selected').val());
        } else {
            $('#tenant_jobs_2_country option').each(function () {
                if ($(this).val() !== 'CA' && $(this).val() !== '') {
                    $(this).prop('hidden', true);
                } else {
                    $(this).prop('hidden', false);
                }
            });
            $('#tenant_jobs_2_country option[value=CA]').prop('selected', true);
            setPostalCodeMask($('#tenant_jobs_2_postalCode'), 'CA');
        }

        internationalJ2.on('change', function () {

            if ($(this).is(':checked')) {
                $('#tenant_jobs_2_state').find('option:selected').removeAttr('selected');
                $('#tenant_jobs_2_postalCode').val($('#tenant_jobs_2_postalCode').attr('value'));
                $('.bmd-help-2').hide();

                $('#tenant_jobs_2_country').val($('#tenant_jobs_2_country option:first').val());
                $('#tenant_jobs_2_country option').each(function () {
                    if ($(this).val() === 'CA') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('.state-label').hide();
                $('.state-label-interational').show();

                //Remove the default Province if it was Canada
                getStatesOfCountry($('#tenant_jobs_2_state'), 'IO');
                setPostalCodeMask($('#tenant_jobs_2_postalCode'), 'IO');
                $('#tenant_jobs_2_state option:first').prop('selected', true);
            } else {
                $('#tenant_jobs_2_country option').each(function () {
                    if ($(this).val() !== 'CA' && $(this).val() !== '') {
                        $(this).prop('hidden', true);
                    } else {
                        $(this).prop('hidden', false);
                    }
                });
                $('#tenant_jobs_2_state').val($('#tenant_jobs_2_state option:first').val());
                $('#tenant_jobs_2_country').val($('#tenant_jobs_2_country option:first').val());
                $('.bmd-help-2').show();
                $('.state-label-interational').hide();
                $('.state-label').show();

                //Remove the default Province if it was Canada
                getStatesOfCountry($('#tenant_jobs_2_state'), 'CA');
                setPostalCodeMask($('#tenant_jobs_2_postalCode'), 'CA');
                $('#tenant_jobs_2_state option:first').prop('selected', true);
            }
        });
    }

    /**
     * Delete user account
     */
    var deleteAccountButton = $('#delete-account');
    var deleteAccountModal = $('#confirmDeleteAccountModal');

    deleteAccountButton.on('click', function () {
        deleteAccountModal.modal('show');

        deleteAccountModal.find('.btn-form-delete').off('click');
        deleteAccountModal.find('.btn-form-delete').click(function () {
            window.location.href = $(this).data('url');
        });
    });

    /**
     * Step 5 add email/sms
     */
    var showEmail = $('#show-email');
    var showSms = $('#show-sms');
    var addEmail = $('#add-email');
    var addEmailButton = $('#add-email-button');
    var addSms = $('#add-sms');
    var addSmsButton = $('#add-sms-button');

    showEmail.on('click', function () {
        addEmail.show();
        addEmailButton.show();
    });

    showSms.on('click', function () {
        addSms.show();
        addSmsButton.show();
    });

    // Save tenant email
    addEmail.on('blur', function () {
        $('#add-email-error').hide();

        if ($(this).val()) {
            var re = /\S+@\S+\.\S+/;
            if (re.test($(this).val())) {
                $.ajax({
                    method: 'POST',
                    data: {
                        addEmail: $(this).val()
                    },
                    success: function (response) {
                        $('#signatureType_email').prop('disabled', false);
                        $('#show-email').hide();
                        $('#cannot-send-email').hide();
                        $('#tenant-email').hide();
                    },
                    error: function (response) {
                        console.log(response);
                    }
                });
            } else {
                $('#add-email-error').show();
            }
        }
    });

    // Save tenant cellular
    addSms.on('blur', function () {
        if ($(this).val()) {
            $.ajax({
                method: 'POST',
                data: {
                    addSms: $(this).val()
                },
                success: function (response) {
                    $('#signatureType_sms').prop('disabled', false);
                    $('#show-sms').hide();
                    $('#cannot-send-sms').hide();
                    $('#tenant-sms').hide();
                    $('#tenant-phone').hide();
                    window.location.reload();
                },
                error: function (response) {
                    console.log(response);
                }
            });
        }
    });

    /**
     * Remove address
     */
    var addressButton = $('.delete-address-button');

    addressButton.on('click', function () {
        var deleteAddressModel = $('#confirmDeleteAddressModal');
        var type = $(this).data('type');
        var id = $(this).data('id');
        deleteAddressModel.modal('show');

        deleteAddressModel.find('.btn-form-delete').off('click');
        deleteAddressModel.find('.btn-form-delete').click(function () {
            if (type === 'address') {
                $.ajax({
                    method: 'POST',
                    data: {
                        deleteAddress: id
                    },
                    success: function () {
                        window.location.reload();
                    }
                });
            } else if (type === 'building') {
                $.ajax({
                    method: 'POST',
                    data: {
                        deleteBuilding: id
                    },
                    success: function () {
                        window.location.reload();
                    }
                });
            }
        });
    });

    var requestForm = $('.request-form');

    requestForm.on('submit', function(){
        var requestFormSubmit = $('.request-form-submit');

        if(requestFormSubmit) {
            requestFormSubmit.prop('disabled', true);

            var glassPanel = document.querySelector('.glasspanel');

            if(glassPanel) {
                glassPanel.classList.remove('disabled');
            }
        }
    });

    var $radioWithTenant = $('input[name="withTenant"]');
    var $requestFormSubmit = $('.request-form-submit');
    var $tenantAcceptConditionsCheckbox = $('#tenant_accept_conditions');
    var $withTenantInfos = $('#with-tenant-infos');

    displayFieldInfo($radioWithTenant.filter(':checked'));

    $radioWithTenant.on('change', function() {
        displayFieldInfo($(this));
        updateRequestFormSubmit();
    });

    $tenantAcceptConditionsCheckbox.on('change', function() {
        updateRequestFormSubmit();
    });

    function updateRequestFormSubmit() {
        if ($radioWithTenant.filter(':checked').val() !== '1') {
            $requestFormSubmit.prop('disabled', false);
        } else {
            var isDisabled = !$tenantAcceptConditionsCheckbox.is(':checked');
            $requestFormSubmit.prop('disabled', isDisabled);
        }
    }

    function displayFieldInfo($radio) {
        if ($radio.val() === '1') {
            $withTenantInfos.show();
            updateRequestFormSubmit();
        } else {
            $withTenantInfos.hide();
            $tenantAcceptConditionsCheckbox.prop('checked', false);
            updateRequestFormSubmit();
        }
    }
})();
